import type { AllRouteEndpoints } from "../routeTypes";

export const postAppGroupIdOperatorMcpConnectionsConnectionIdCallToolCacheKeys: AllRouteEndpoints[] = [];
